import { combineReducers } from 'redux';
import initializePurchase from './InitializePurchaseReducers';
import finalizePurchase from './FinalizePurchaseReducers';
import settings from './SettingsReducers';
import offerDetails from './OfferDetailsReducers';
import refinePurchase from './RefinePurchaseReducers';
import { finalizeSocialPay } from './FinalizeSocialPayReducers';
import { socialPay } from './SocialPayReducers';
import { pageState } from 'reducers/PageStateReducers';

const rootReducer = combineReducers({
  settings,
  initializePurchase,
  refinePurchase,
  finalizePurchase,
  finalizeSocialPay,
  pageState,
  socialPay,
  offerDetails,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/payments/reducers/products.js